import HelpApi from '@/api/help/common';
import {helpApiBase} from '@/api/help/index';
import {
  SubmitFormPayload,
  FormSubmitResponse,
  UploadTempFilesResponse,
  CommonSubCategoryResponse,
} from '@/api/help/form/type';
import {
  FORM_TYPE_INQUIRY,
  FORM_TYPE_REPORT,
  FORM_TYPE_ILLEGAL,
  FORM_TYPE_OBJECTION,
  OBJECTION_DOMAIN_ID,
} from '@/constants/help/index';

/* ------------------------------ 임시 파일 업로드 ------------------------------ */

export const helpTempFile = (formData: FormData) => {
  return HelpApi.post('/tempfile.php', formData, {});
};

/**
 * 임시 파일을 업로드하고 ticketId 반환
 * @param files - 업로드할 File 객체 배열
 * @returns {Promise<UploadTempFilesResponse>}
 */
export const uploadTempFiles = async (
  files: File[],
): Promise<UploadTempFilesResponse> => {
  const formData = new FormData();

  files.forEach((file) => {
    formData.append('files[]', file);
  });

  try {
    const response = await helpTempFile(formData);
    return response;
  } catch (error) {
    console.error('파일 업로드 API 호출 실패:', error);
    throw new Error('파일 업로드 중 오류가 발생했습니다.');
  }
};

export const uploadFilesAndGetTicket = async (files?: File[]): Promise<string | undefined> => {
  if (!files?.length) {
    return;
  }

  const {errorCode, ticketId} = await uploadTempFiles(files);
  if (errorCode !== 0) {
    throw new Error('파일 업로드 중 오류가 발생했습니다.');
  }
  return ticketId;
};

/* ------------------------------ 공통 페이지: 카테고리 세부유형 조회 ------------------------------ */

export const getCommonSubCategory = (
  parentId: string,
): Promise<CommonSubCategoryResponse> => {
  return helpApiBase({
    command: 'CommonNodeList',
    domainId: 'sooplive',
    parentId: parentId,
    serviceType: 'SVQNA',
  });
};

/* ------------------------------ 폼 제출 ------------------------------ */

export const FORM_TYPE_TO_API = {
  [FORM_TYPE_INQUIRY]: 'exMailQuestion',
  [FORM_TYPE_REPORT]: 'exMailDeclare',
  [FORM_TYPE_ILLEGAL]: 'exMailIllegal',
  [FORM_TYPE_OBJECTION]: 'exMailObjection',
} as const;

export const postHelpForm = (
  payload: SubmitFormPayload,
): Promise<FormSubmitResponse> => {
  const type = payload.isMobile
    ? 'questionMobile'
    : FORM_TYPE_TO_API[payload.formType];

  const domainId =
    FORM_TYPE_TO_API[payload.formType] === 'exMailObjection'
      ? OBJECTION_DOMAIN_ID
      : 'sooplive';

  const params: Record<string, any> = {
    type,
    command: 'QnaRegister',
    domainId,
    nodeId: payload.nodeId,
    customerEmail: payload.customerEmail,
    questionTitle: encodeURIComponent(payload.title),
    questionContents: encodeURIComponent(payload.content),
    inChannelId: 'CHNL0000000005',
  };

  if (payload.isGuest) {
    params.nonmemberFlag = 'Y';
    params.password = 'soop20241015';
  }

  if (payload.ticketId) {
    params.ticketId = payload.ticketId;
  }

  return helpApiBase(params);
};
